var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoLocationsSmall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5175 64.4264C35.8388 65.2343 33.0627 65.1804 31.2549 64.3187L21.2477 59.4716C19.5046 58.6099 19.3754 57.2635 21.0541 56.4556C22.7327 55.6478 25.5089 55.7017 27.3166 56.5634L37.3238 61.4104C39.1315 62.2722 39.1961 63.6186 37.5175 64.4264Z",
    fill: "url(#paint0_linear_1407_363405)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9153 34.1854C52.9153 38.2248 51.7795 41.4957 49.6615 43.494C49.6615 43.494 49.2175 43.9125 49.1577 43.9637L41.2411 50.1723L36.8259 53.631L36.7576 53.6652L28.2005 58.6269L38.3802 50.642L40.5408 48.9511C40.6091 48.8999 41.0447 48.4814 41.0447 48.4814C41.5912 47.9605 42.0695 47.3627 42.4879 46.6795C43.675 44.7323 44.2984 42.1618 44.2984 39.1642C44.2984 36.4912 43.8031 33.6645 42.9235 30.8548C41.3009 25.671 38.3375 20.547 34.6653 16.5417C33.7173 15.4999 32.7096 14.5434 31.6763 13.6723C30.5404 12.7243 29.3619 11.8874 28.1492 11.1871C26.6035 10.299 25.109 9.69264 23.6999 9.3425C21.1464 8.71054 18.8577 8.94112 16.9874 9.92322L25.2456 5.14081L25.442 5.02979C25.442 5.02979 25.5018 4.99563 25.5274 4.97855C28.431 3.39865 32.3936 3.68047 36.7661 6.19977C37.9702 6.90006 39.1488 7.73698 40.2846 8.68492C47.5095 14.7142 52.9067 25.2696 52.9153 34.1769V34.1854Z",
    fill: "url(#paint1_linear_1407_363405)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1406 58.6617L28.1756 58.6442L28.1406 58.6617Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9234 30.8634C41.3008 25.6796 38.3374 20.5556 34.6652 16.5503C33.7173 15.5084 32.7095 14.552 31.6762 13.6809C30.5404 12.7329 29.3619 11.896 28.1492 11.1957C26.6034 10.3076 25.1089 9.70124 23.6998 9.3511C21.1464 8.71913 18.8576 8.94971 16.9874 9.93182L16.4664 10.2393C13.6995 11.99 12.0085 15.5341 12 20.5214C12 21.8964 12.1281 23.3396 12.3928 24.8171C12.8882 27.6694 13.8617 30.667 15.2537 33.5877C15.2537 33.5877 15.6978 34.51 15.7661 34.6466L23.2899 49.2415L28.1492 58.6612L28.1833 58.6441L38.363 50.6506L40.5237 48.9597C40.592 48.9085 41.0275 48.49 41.0275 48.49C41.5741 47.9691 42.0523 47.3713 42.4708 46.6881C43.6578 44.7409 44.2813 42.1704 44.2813 39.1728C44.2813 36.4998 43.7859 33.6731 42.9063 30.8634H42.9234ZM31.5139 37.3453C30.566 37.5673 29.4046 37.3453 28.1492 36.6279C24.904 34.7576 22.2736 30.1973 22.2736 26.4567C22.2736 24.3303 23.1191 22.9212 24.4428 22.4429C25.4505 22.0757 26.7401 22.2551 28.1406 23.0664C31.3858 24.9366 34.0162 29.497 34.0162 33.2375C34.0162 35.5348 33.0255 36.9951 31.5139 37.3453V37.3453Z",
    fill: "#D7D7D7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0162 33.2375C34.0162 35.5348 33.0256 36.9951 31.514 37.3452C30.566 37.5673 29.4046 37.3452 28.1492 36.6279C24.904 34.7576 22.2737 30.1972 22.2737 26.4567C22.2737 24.3303 23.1191 22.9212 24.4428 22.4429C25.4506 22.0757 26.7401 22.255 28.1407 23.0663C31.3859 24.9366 34.0162 29.497 34.0162 33.2375V33.2375Z",
    fill: "url(#paint2_linear_1407_363405)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1407_363405",
    x1: 29.2717,
    y1: 66.1345,
    x2: 33.7639,
    y2: 56.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#525252",
    stopOpacity: 0.05
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1407_363405",
    x1: 17.124,
    y1: 9.12401,
    x2: 44.452,
    y2: 49.2621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211673,
    stopColor: "#E7E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.425569,
    stopColor: "#EEEEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.550544,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.709325,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8",
    stopOpacity: 0.68
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1407_363405",
    x1: 23.9902,
    y1: 22.6564,
    x2: 32.2997,
    y2: 37.0378,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A8A8A8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoLocationsSmall);
export default __webpack_public_path__ + "static/media/no_locations_small.94a8844503c8664427dfea3127433647.svg";
export { ForwardRef as ReactComponent };